import useBrand from 'hooks/useBrand'

import styles from './Header.module.scss'

const SavibookHeader = ({ text, isColored }) => {
  const { colors, logoUrl } = useBrand()

  return (
    <div
      className={styles.header}
      style={{ background: isColored ? colors.primary : 'transparent' }}
    >
      <img className={styles.logo} src={logoUrl} alt="" />
      {text && <div className={styles.for}>{text}</div>}
    </div>
  )
}

export default SavibookHeader
